import React, { useContext, useState, useEffect } from "react";
import { AppBar, Button, Menu, MenuItem, Toolbar } from "@mui/material";
import { styled } from "@mui/system";
import { useTranslation } from "react-i18next";
import { AppConfig } from "../../context/context";
import { APP_LANGUAGES } from "../../utils/constants";
import ArrowDropDownSharpIcon from "@mui/icons-material/ArrowDropDownSharp";

const TopNav = styled("div")({
  ".topNav": {
    backgroundColor: "transparent !important",
  },
  ".menuItem": {
    display: "flex !important",
    padding: "6px 16px !important",
    justifyContent: "flex-start !important",
  },
  ".toolbar": {
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "& h3": {
      color: "var(--kyocera-dark-grey)",
    },
  },
  ".languageButton": {
    width: 110,
    margin: 10,
    textTransform: "none",
    color: "var(--kyocera-dark-grey)",
  },
});

const MainTopNavComponent = () => {
  const { i18n } = useTranslation();
  const { config } = useContext(AppConfig);
  const [languageMenuEl, setLanguageMenuEl] = useState<null | HTMLElement>(
    null
  );
  const [userLanguage, setUserLanguage] = useState<string>("en");

  useEffect(() => {
    if (config.language) {
      setUserLanguage(config.language);
      i18n.changeLanguage(config.language);
    }
  }, [config.language]);

  const handleLanguageClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setLanguageMenuEl(event.currentTarget);
  };

  const handleLanguageClose = async () => {
    setLanguageMenuEl(null);
  };

  return (
    <TopNav>
    {/*
    <AppBar position="static" className ="topNav">
      <Toolbar className ="toolbar">
        <h3></h3>
        <div>
          <Button onClick={handleLanguageClick} className="languageButton">
            {APP_LANGUAGES[userLanguage].full}
            <ArrowDropDownSharpIcon />
          </Button>
          <Menu
            id="language-menu"
            anchorEl={languageMenuEl}
            keepMounted
            open={Boolean(languageMenuEl)}
            onClose={handleLanguageClose}
            // getContentAnchorEl={null}
            // anchorOrigin={{
            //   vertical: "bottom",
            //   horizontal: "center",
            // }}
            // transformOrigin={{
            //   vertical: "top",
            //   horizontal: "center",
            // }}
          >
            {Object.entries(APP_LANGUAGES).map((value) => (
              <MenuItem
                className = "menuItem"
                onClick={() => {
                  const locale = value[1].code;
                  setUserLanguage(locale);
                  i18n.changeLanguage(locale);
                  handleLanguageClose();
                }}
                key={value[1].code}
                dense
              >
                {value[1].full}
              </MenuItem>
            ))}
          </Menu>
        </div>
      </Toolbar>
    </AppBar>
    */}
    </TopNav>
  );
};

export default MainTopNavComponent;
